import { useState, useEffect } from "react";
const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const RULE_DESC = {
  "Auto-fermeture tickets résolus": { ic:"🔒", desc:"Ferme automatiquement les tickets résolus depuis plus de 7 jours", freq:"Toutes les heures" },
  "Escalade tickets anciens":       { ic:"⬆️", desc:"Passe en priorité urgente les tickets ouverts > 48h", freq:"Toutes les 30min" },
  "Alertes stock rupture":          { ic:"📦", desc:"Détecte les produits en rupture de stock", freq:"Toutes les heures" },
  "Maintenance préventive auto":    { ic:"🔧", desc:"Crée des tickets de maintenance pour les clients sans intervention > 6 mois", freq:"Quotidien" },
  "Rapport hebdomadaire":           { ic:"📊", desc:"Génère un rapport chaque lundi matin à 8h", freq:"Hebdomadaire" },
};

export default function AutomationsView({ T }) {
  const [status, setStatus] = useState([]);
  const [logs, setLogs]     = useState([]);
  const [running, setRunning] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const [s, l] = await Promise.all([
      fetch(`${BASE}/automations/status`, {headers:h()}).then(r=>r.json()).catch(()=>({rules:[],status:[]})),
      fetch(`${BASE}/automations/logs`, {headers:h()}).then(r=>r.json()).catch(()=>[]),
    ]);
    setStatus(s.status||[]);
    setLogs(Array.isArray(l)?l:[]);
    setLoading(false);
  };

  useEffect(()=>{ load(); const iv=setInterval(load,30000); return ()=>clearInterval(iv); },[]);

  const runRule = async(name) => {
    setRunning(name);
    await fetch(`${BASE}/automations/run/${encodeURIComponent(name)}`,{method:"POST",headers:h()}).catch(()=>{});
    await load();
    setRunning(null);
  };

  const RULES = Object.keys(RULE_DESC);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <div style={{fontSize:22,fontWeight:800,color:T.text,letterSpacing:"-0.5px"}}>⚡ Automatisations</div>
          <div style={{fontSize:13,color:T.muted,marginTop:2}}>{RULES.length} règles actives · Rafraîchissement toutes les 30s</div>
        </div>
        <button onClick={load} style={{padding:"8px 16px",borderRadius:9,border:`1px solid ${T.border}`,background:T.card,color:T.text,fontSize:12,fontWeight:600,cursor:"pointer"}}>
          🔄 Actualiser
        </button>
      </div>

      {/* Règles */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        {RULES.map(name => {
          const info = RULE_DESC[name];
          const stat = status.find(s=>s.rule_name===name);
          const isRunning = running===name;
          const lastResult = stat?.last_result ? JSON.parse(typeof stat.last_result==="string"?stat.last_result:JSON.stringify(stat.last_result)) : null;
          return (
            <div key={name} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:"16px 18px",display:"flex",flexDirection:"column",gap:10}}>
              <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:12}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                    <span style={{fontSize:18}}>{info.ic}</span>
                    <span style={{fontSize:13,fontWeight:700,color:T.text}}>{name}</span>
                    <span style={{fontSize:9,fontWeight:700,color:"#10b981",background:"#10b98115",padding:"2px 7px",borderRadius:99}}>ACTIF</span>
                  </div>
                  <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>{info.desc}</div>
                </div>
                <button onClick={()=>runRule(name)} disabled={!!running}
                  style={{padding:"7px 12px",borderRadius:8,border:`1px solid ${T.accent}40`,background:T.accentDim,color:T.accent,fontSize:11,fontWeight:700,cursor:"pointer",flexShrink:0,opacity:running?0.6:1,whiteSpace:"nowrap"}}>
                  {isRunning?"⏳ En cours...":"▶ Lancer"}
                </button>
              </div>
              <div style={{display:"flex",gap:12,fontSize:11,color:T.muted,borderTop:`1px solid ${T.border}`,paddingTop:10}}>
                <span>🕐 {info.freq}</span>
                {stat?.last_run&&<span>Dernier run: {new Date(stat.last_run).toLocaleString("fr-FR",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"})}</span>}
                {stat?.runs_total&&<span>Exécutions: {stat.runs_total}</span>}
                {lastResult?.count>0&&<span style={{color:"#10b981",fontWeight:700}}>✅ {lastResult.count} action(s)</span>}
              </div>
            </div>
          );
        })}
      </div>

      {/* Polling temps réel */}
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:"16px 18px"}}>
        <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>🔄 Synchronisation temps réel</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
          {[
            {ic:"🎫",lbl:"Tickets",freq:"30 secondes"},
            {ic:"🔧",lbl:"Interventions",freq:"30 secondes"},
            {ic:"📦",lbl:"Stock",freq:"Au scan mobile"},
          ].map(item=>(
            <div key={item.lbl} style={{background:T.bg,borderRadius:10,padding:"12px 14px",display:"flex",alignItems:"center",gap:10}}>
              <span style={{fontSize:20}}>{item.ic}</span>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:T.text}}>{item.lbl}</div>
                <div style={{fontSize:11,color:"#10b981"}}>✅ Sync: {item.freq}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Logs récents */}
      {logs.length>0&&(
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:"16px 18px"}}>
          <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>📋 Logs récents</div>
          <div style={{display:"flex",flexDirection:"column",gap:6}}>
            {logs.slice(0,10).map((log,i)=>(
              <div key={i} style={{display:"flex",gap:12,padding:"8px 12px",background:T.bg,borderRadius:8,fontSize:12}}>
                <span style={{color:T.muted,flexShrink:0}}>{new Date(log.created_at).toLocaleString("fr-FR",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"})}</span>
                <span style={{fontWeight:600,color:T.text}}>{log.type}</span>
                <span style={{color:T.muted,fontFamily:"monospace",fontSize:10}}>{JSON.stringify(log.data).slice(0,80)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
